<template>
  <div :style='{
     width:width??48+"px",
     height:height??48+"px",
     borderRadius: radius??4+"px",
     backgroundColor:"white",
     border:"#eee 1px solid",
     overflow: "hidden"
  }'>
    <img alt="" v-if="(useUser.avatar === '' || !useUser.isLogin) && HNewGameUIConfig.newGameUIType === 0" :src="icon_default_avatar" width="100%" height="100%"/>
    <HCacheImage v-if="(useUser.avatar !== '' && useUser.isLogin) && HNewGameUIConfig.newGameUIType === 0" :src="useUser.avatar" :radius="radius??4+'px'" width="100%" height="100%"/>
    <img alt="" v-if="(useUser.avatar === '' || !useUser.isLogin) && HNewGameUIConfig.newGameUIType !== 0" :src="getAvatar()" width="100%" height="100%"/>
  </div>

</template>


<script setup>
  import icon_default_avatar from '@/assets/icons/common/default_avatar.png';
  import HCacheImage from "@/components/utils/HCacheImage.vue";
  import {useUserStore} from "@/stores/useUser.js";
  import {hcf} from "@/components/utils/HComFunctions.js";
  import HNewGameUIConfig from "@/components/utils/HNewGameUIConfig.js";
  const useUser = useUserStore();
  defineProps(["width","height","radius"]);
  const ico_default_avatar_other  =   hcf.getNewGameUIIcon(`default_avatar.png`);

  function getAvatar(){
    if(HNewGameUIConfig.newGameUIType === 0 ){
      return icon_default_avatar;
    }else {
      return ico_default_avatar_other;
    }
  }

</script>

